import Vue from 'vue';
import Checkbox from 'primevue/checkbox';

Vue.component('Checkbox', Checkbox);
